import { BaseHttpResponseError } from './error/apiErrors';

function catchAllErrors<T>(error: T, errorCallback?: (error: T) => void) {
  if (errorCallback) {
    errorCallback(error);
  }

  if (error instanceof BaseHttpResponseError) {
    console.log('ApiError detected:', error);
    console.log(error.serverResponse);
    throw error;
  } else {
    console.log(typeof error);
    console.error(error);
  }
}

export default catchAllErrors;
